<template>
  <!-- header tiles -->
  <input-headers-group v-if="header">
    <input-header>Slot name</input-header>
    <input-header>Related entity</input-header>
    <input-header width="56px"></input-header>
  </input-headers-group>
  <!-- form -->
  <el-form-sub v-else ref="form"
    :prop="prop"
    :model="value"
    v-on="$listeners"
    label-width="120px"
    :hide-required-asterisk="true">
    <!-- the button group -->
    <el-button-group style="width: 100%">
      <!-- slot name input -->
      <comparable prop="value.name" default=""
        :required="true" :rules="nameRules"
        @input="v => $emit('update:name', v)">
        <template v-slot="{ attrs, listeners, status, view, compare }">
          <el-form-small-item
            :class="'comparable-' + status"
            :prop="view && 'name'"
            v-bind="attrs"
            field="name">
            <el-entity-input
              :value="value.name"
              v-on="listeners"
              :style-obj="styleObj"
              :disabled="compare"
              :placeholder="placeholder || 'Slot name'">
            </el-entity-input>
          </el-form-small-item>
        </template>
      </comparable>
      <!-- slot entity selector -->
      <comparable prop="value.entity" default="">
        <template v-slot="{ status, view, compare }">
          <el-form-small-item
            :rules="entityRules"
            :class="'comparable-' + status"
            :prop="view && 'entity'"
            field="entity">
            <el-filterable-entity-select
              v-model="value.entity"
              @input="() => { value.key = null }"
              type="entity"
              :disabled="compare"
              :clearable="!compare"
              placeholder="Entity"
              :options="localVariables">
            </el-filterable-entity-select>
          </el-form-small-item>
        </template>
      </comparable>
      <!-- delete button -->
      <comparator-filter>
        <template v-slot="{ compare }">
          <el-button
            icon="el-icon-delete"
            @click="$emit('delete')"
            :tabindex="-1"
            :disabled="compare || !deletable">
          </el-button>
        </template>
      </comparator-filter>
    </el-button-group>
  </el-form-sub>
</template>

<script>
import { VariableValidator } from '../../utils/validators.js'

import ElFilterableEntitySelect from '../element/ElFilterableEntitySelect.vue'
import ElEntityInput from '../element/ElEntityInput.vue'

export default {
  name: 'SlotEditor',

  components: {
    ElFilterableEntitySelect,
    ElEntityInput,
  },

  props: {
    value: Object,
    other: Object, // a value to compare with
    header: Boolean, // true for displaying only the "table" headers
    duplicateName: Boolean, // true if the slot name is already used
    duplicateEntity: Boolean, // true if the slot entity is already used
    // true if the entty can be disabled despite being related
    deletable: Boolean,
    prop: String, // the prop prefix to use for el-form-item
    rules: [Object, Array], // el-form-item additional rules
    placeholder: String, // a placeholder for an empty entity name
    // for the default value input
    localVariables: Array,
    styleObj: Object,
  },

  computed: {
    /* merges the rules */
    nameRules () {
      return [ VariableValidator,
        {
          validator: (rule, value, callback) => callback(this.duplicateName
            ? new Error('duplicated slot name') : undefined),
          trigger: 'blur',
        }].concat(this.rules || [])
    },
    entityRules () {
      return {
        validator: (rule, value, callback) => callback(this.duplicateEntity
          ? new Error('duplicated slot entity') : undefined),
      }
    },
    validate (callback) {
      return this.$refs.form.validate(callback)
    },
  },
}
</script>
